import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { linkedAccountsForGlobalProcedure } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchLinkedAccountsForGlobalProcedure({
  accountId,
  procedureId,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    linkedAccountsForGlobalProcedure(accountId, procedureId),
    {
      method: 'GET',
      headers: {
        Authorization: getTokenWithType(),
      },
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<string> | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
  procedureId: number;
};

function useGetLinkedAccountsForGlobalProcedure({
  accountId,
  procedureId,
}: TVariables): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_linked_accounts', accountId, procedureId],
    async () => {
      if (procedureId)
        return await fetchLinkedAccountsForGlobalProcedure({
          accountId,
          procedureId,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetLinkedAccountsForGlobalProcedure };
